// extracted by mini-css-extract-plugin
export default {"loader":"circularProgressLoader_loader__3LJOE","blackLoader":"circularProgressLoader_blackLoader__qDx6E"};